import { IBreadcrumbItem } from 'office-ui-fabric-react/lib/Breadcrumb';
import { BreadCrumbsActiontypes, IBreadCrumbsAction } from '../../Actions/BreadCrumbs/ActionTypes';

const emptyBC: IBreadcrumbItem[] = [];

export const initialState: IBreadCrumbsState = {
  items: emptyBC
};

export interface IBreadCrumbsState {
  items: IBreadcrumbItem[];
}

export function reducer(state = initialState, action: IBreadCrumbsAction) {
  switch (action.type) {
    case BreadCrumbsActiontypes.UPDATE:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}
